import type { School } from '../../modules/platform/types';
import type { SchoolFeatureFlagKey, SchoolFeatureFlagsSnapshot } from '../../modules/platform/types/school';

/** Canonical 11 keys for GET normalization and PATCH payload (independent of UI sections). */
export const SCHOOL_FEATURE_FLAG_KEYS_ALL: readonly SchoolFeatureFlagKey[] = [
  'roster',
  'learning',
  'homework',
  'chat',
  'rewards',
  'ai_tutor',
  'communication_tutor',
  'scenario_based_convo',
  'grammar',
  'picture_talk',
  'story_studio',
] as const;

export const CORE_SCHOOL_FEATURE_FLAGS: { key: SchoolFeatureFlagKey; label: string }[] = [
  { key: 'roster', label: 'Roster' },
  { key: 'learning', label: 'Learning' },
  { key: 'homework', label: 'Homework' },
  { key: 'chat', label: 'Chat' },
  { key: 'rewards', label: 'Rewards' },
];

export const LEARNING_EXPERIENCE_FEATURE_FLAGS: { key: SchoolFeatureFlagKey; label: string }[] = [
  { key: 'ai_tutor', label: 'AI tutor' },
  { key: 'communication_tutor', label: 'Communication tutor' },
  { key: 'scenario_based_convo', label: 'Scenario conversation' },
  { key: 'grammar', label: 'Grammar / writing' },
  { key: 'picture_talk', label: 'Picture talk' },
  { key: 'story_studio', label: 'Story studio' },
];

/** Normalize GET payload into a full 11-key boolean snapshot (missing → false). */
export function buildFeatureFlagsSnapshot(school: School): SchoolFeatureFlagsSnapshot {
  const raw = school.school_settings?.feature_flags ?? {};
  const snapshot = {} as SchoolFeatureFlagsSnapshot;
  for (const key of SCHOOL_FEATURE_FLAG_KEYS_ALL) {
    snapshot[key] = raw[key] === true;
  }
  // Preserve any extra boolean flags already stored by the backend.
  for (const [k, v] of Object.entries(raw)) {
    if (!(k in snapshot) && typeof v === 'boolean') {
      (snapshot as Record<string, boolean>)[k] = v;
    }
  }
  return snapshot;
}
